import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const PageNotFound = lazy(() => import('@components/error/404/PageNotFound'));
const CommunityBoardRouter = lazy(() => import('@shared/layout/dashboard/components/community-board/CommunityBoardRouter'));
const ClinicsPage = lazy(() => import('@shared/layout/dashboard/components/clinics/ClinicsPage'));
const DentistPage = lazy(() => import('@shared/layout/dashboard/components/dentists/DentistsPage'));
const HomePage = lazy(() => import('@shared/layout/dashboard/components/home/HomePage'));
const LabOrdersPage = lazy(() => import('@shared/layout/dashboard/components/lab-orders/LabOrdersPage'));
const LaboratoryPage = lazy(() => import('@shared/layout/dashboard/components/labs/LaboratoryPage'));
const ProfilePage = lazy(() => import('@shared/layout/dashboard/components/profile-page/ProfilePage'));
const ReferralsPage = lazy(() => import('@shared/layout/dashboard/components/referrals/ReferralsPage'));
const SendReferralOrderPage = lazy(() => import('@shared/layout/dashboard/components/send-referral-order/SendReferralOrderPage'));
const TopDentistsCustomersPage = lazy(() => import('@shared/layout/dashboard/components/top-dentists-customers/TopDentistsCustomersPage'));
const ClinicListPage = lazy(() => import('./clinics/ClinicListPage'));

const DentistRouter = () => (
  <Routes>
    <Route path="community-board/*" element={<CommunityBoardRouter />} />
    <Route path="lab-orders/:status" element={<LabOrdersPage />} />
    <Route path="profile/:id/affiliated-dentists" element={<DentistPage />} />
    <Route path="my-clinics/:tab" element={<ClinicListPage />} />
    <Route path="profile/:id" element={<ProfilePage />} />
    <Route path="view/:id/:type" element={<SendReferralOrderPage />} />
    <Route path="send/:type" element={<SendReferralOrderPage />} />
    <Route path="labs" element={<LaboratoryPage />} />
    <Route path="clinics" element={<ClinicsPage />} />
    <Route path="dentists" element={<DentistPage />} />
    <Route path="referrals/:status" element={<ReferralsPage />} />
    <Route path="top-dentists" element={<TopDentistsCustomersPage />} />
    <Route index element={<HomePage />} />
    <Route path="*" element={<PageNotFound />} />
  </Routes>
);

export default DentistRouter;
